(function() { window.GUID_03010ffa_81af_4f20_b769_81e4f124a8d7 = { getGuid: function() { return "03010ffa-81af-4f20-b769-81e4f124a8d7"; } }; })();
var CS;
(function (CS) {
    class DatePicker extends CS.Calendar {
        constructor(inputBox) {
            super(inputBox, false);
        }
        ShowCalendar() {
            console.log("showcalendar done");
            this.CSDatePicker.datepicker('show');
        }
    }
    CS.DatePicker = DatePicker;
})(CS || (CS = {}));
/*
(function ($) {
    $.fn.CSDatePicker = function () {
        this.each(function () {
            var datePicker = new CS.DatePicker($(this));

            //Donne access au datepicker de n'importe quels scripts.
            eval('document.' + datePicker.DatePickerId + '=datePicker;');
        });
    };
})(jQuery);


var CS = CS || {};

CS.DatePicker = function (inputBox) {
    var me = this;
    
    me.InputBox = inputBox;
    me.InputBox.data('context', me);
    me.SelectionChange = null;
    me.val = function (newVal) {
        if (newVal != null) {
            inputBox.datepicker('setDate', newVal);
            inputBox.trigger('change');

        }
        else {
            return me.InputBox.val();
        }
    };

    me.DatePickerId = inputBox[0].id;

    ///**************** /
    this.CSDatePicker = inputBox.datepicker({
        //dateFormat: dateFormat,
        changeMonth: true,
        changeYear: true,
        numberOfMonths: 1,
        yearRange: "-100:+5",

        beforeShowDay: function (d) {
            //ScheduleDates vient de la des vues qui applique JSArrayHelper
            if (typeof ScheduledDates !== 'undefined' && ScheduledDates != null) {
                var year = d.getFullYear();
                var month = d.getMonth() + 1;
                var day = d.getDate();

                if (month.toString().length == 1) {
                    month = '0' + month;
                }
                if (day.toString().length == 1) {
                    day = '0' + day;
                }
                var result = year + '-' + month + '-' + day;

                if ($.inArray(result, ScheduledDates) != -1) {
                    //[0] = true/false (isEnable or not                //[1] = CSS class                //[2] = tooltip
                    return [true, "HighlightedDayDatePicker", "Available"];
                }
                else {
                    return [true, "NotHighlightedDayDatePicker", "unAvailable"];
                }
            }
            else {
                return [true, "NotHighlightedDayDatePicker", "unAvailable"];

            }
        },
        showButtonPanel: true

    });

    this.ActualSelectedDate = this.CSDatePicker.datepicker('getDate');
 
    inputBox.on('keyup', function (e) {
        if (e.keyCode == "13") {
            me.InputBox.trigger('blur');
        }
    }).on('change', function () {
        var newStartDate = me.CSDatePicker.datepicker('getDate');

        if (newStartDate != null && (me.ActualSelectedDate == null || newStartDate.toString() != me.ActualSelectedDate.toString())) {
            if (me.ActualSelectedDate != null) {
                var diffYear = me.ActualSelectedDate.getFullYear() - newStartDate.getFullYear();
                var diffMonth = me.ActualSelectedDate.getMonth() - newStartDate.getMonth();
                var diffDay = me.ActualSelectedDate.getDate() - newStartDate.getDate();

                me.OffsetYear = diffYear;
                me.OffsetMonth = diffMonth;
                me.OffsetDay = diffDay;
            }
            else {
                me.OffsetYear = 0;
                me.OffsetMonth = 0;
                me.OffsetDay = 0;
            }
            me.ActualSelectedDate = newStartDate;

            if (me.SelectionChange != null)
                me.SelectionChange.call(me);

            me.InputBox.trigger("CSChange", me);

            $('.DummyInput').focus();

        }
    });

    return me;
};


CS.DatePicker.prototype = function () {

    var ShowCalendar = function () {
        this.CSDatePicker.datepicker('show');
    };
    return {
        ShowCalendar: ShowCalendar
    };

}();


//Ici, ça fait en sorte que dans le datepicker, si je clique le bouton
//today, celui-ci sélectionne la date d'aujourd'hui, sinon, il ne ferait que
//naviguer faire la date sans la sélectionner.
$.datepicker._gotoToday = function (id) {
    var target = $(id);
    var inst = this._getInst(target[0]);
    if (this._get(inst, 'gotoCurrent') && inst.currentDay) {
        inst.selectedDay = inst.currentDay;
        inst.drawMonth = inst.selectedMonth = inst.currentMonth;
        inst.drawYear = inst.selectedYear = inst.currentYear;
    }
    else {
        var date = new Date();
        inst.selectedDay = date.getDate();
        inst.drawMonth = inst.selectedMonth = date.getMonth();
        inst.drawYear = inst.selectedYear = date.getFullYear();
        this._setDateDatepicker(target, date);
        this._selectDate(id, this._getDateDatepicker(target));
    }
    this._notifyChange(inst);
    this._adjustDate(target);
};

*/ 

//# sourceMappingURL=cs.datepicker.js.map
